const ModelPageRoutes = [
    {
        path: "/models/:modelId",
        name: "ModelPage",
        component: () =>
          import(
            /* webpackChunkName: "ModelPageModule" */ "./views/Index.vue"
        ),
    },
    {
        path: "/models/:modelId/upload",
        name: "UploadModel",
        component: () =>
          import(
            /* webpackChunkName: "ModelPageModule" */ "./views/Upload.vue"
        ),
    },
  ];
  
  export default ModelPageRoutes;
  